module.exports = __webpack_public_path__ + "img/img_article6_radio_v3@3x.ab2ee6f8.png";